<!-- @format -->

@if (badgeVariant) {
  <sis-tiny-badge [variant]="badgeVariant" class="flow-state">
    <span>{{ translationKey | translate }}</span>
    @if (publishDate && flowState === "PUBLISHED") {
      <span>&nbsp;{{ publishDate | localDateFormat }}</span>
    }
  </sis-tiny-badge>
}
